import React from "react";
import {Card, CardContent, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

function InstructionCard() {
    const {t} = useTranslation();

    return (
        <Card>
            <CardContent>
                <Typography variant="h5" component="h2" gutterBottom>
                    {t('components:instruction_card.title', 'Инструкция')}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {t('components:instruction_card.content', 'Здесь будет размещена инструкция по использованию приложения.')}
                </Typography>
            </CardContent>
        </Card>
    );
}

export default InstructionCard;

